module.exports = __webpack_public_path__ + "static/media/groundingVideo.1fb6d00b.mp4";